import React, { Component } from 'react';

class App extends Component {
    constructor() {
        super();
        this.state = {
            sec: 0,
            chatData: []
        }
        let count;
        this.timerInterval = setInterval(() => {
            count = this.state.sec++;
            this.setState({
                sec: this.state.sec
            })
        }, 1000);
    }

    componentWillReceiveProps = (nextProps) => {
        if (!nextProps.isTimerOn) {
            clearInterval(this.timerInterval);
        }
    }

    render() {
        var m = ("0" + Math.floor(this.state.sec % 3600 / 60)).slice(-2);
        var s = ("0" + Math.floor(this.state.sec % 3600 % 60)).slice(-2);
        return (
            <div><span>{m}:{s}</span></div>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// /src/call/callTimer/timer.js